// src/components/ui/alert.jsx
import * as React from "react";
import { cn } from "@/lib/utils";

const Alert = React.forwardRef(({ className, variant = "info", ...props }, ref) => {
  const variants = {
    info: "bg-blue-100 text-blue-900 border-blue-200",
    success: "bg-green-100 text-green-900 border-green-200",
    warning: "bg-yellow-100 text-yellow-900 border-yellow-200",
    error: "bg-red-100 text-red-900 border-red-200",
  };

  return (
    <div
      ref={ref}
      className={cn(
        "rounded-md border p-4 text-sm",
        variants[variant],
        className
      )}
      {...props}
    />
  );
});
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn("font-medium leading-tight", className)}
    {...props}
  />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };

